import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for GoalStore, for use in the registry */ export const GoalStoreActionTypes = [
    ActionType.CreateBasicGoalAction,
    ActionType.CreateBasicGoalFailedAction,
    ActionType.CreateBasicGoalSucceededAction,
    ActionType.DeleteBasicGoalAction,
    ActionType.DeleteBasicGoalFailedAction,
    ActionType.DeleteBasicGoalSucceededAction,
    ActionType.FetchBasicGoalsForPlanAction,
    ActionType.FetchBasicGoalsForPlanFailedAction,
    ActionType.FetchBasicGoalsForPlanSucceededAction,
    ActionType.UpdateBasicGoalAction,
    ActionType.UpdateBasicGoalFailedAction,
    ActionType.UpdateBasicGoalSucceededAction,
    ActionType.GenerateTasksForGoalAction,
    ActionType.GenerateTasksForGoalSucceededAction,
    ActionType.GenerateTasksForGoalFailedAction
];
